import React from "react";

const MainHeaderButtonsWrapper = ({ children }) => (
  <div className="flex flex-wrap items-center gap-2 sm:ml-auto w-full sm:w-auto justify-start sm:justify-end">{children}</div>
);

export default MainHeaderButtonsWrapper;
